import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetSalaryInfo, doSaveSalaryInfo, doDeleteSalaryInfo } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import BatchSetDiv from './BatchSetDiv'
class SetAdjustmentPersonDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetSalaryPerson()
    }

    doGetSalaryPerson = (searchString = '') => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetVacationPerson',
            data: { id, searchString },
            onEnd: ({ errorMessage, initValues基本信息, initValues休假人员 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, initValues休假人员 })
                }
            }
        })
    }

    handlerSave = () => {
        const { onSave, onClose } = this.props
        const { id, changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveVacationPerson',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('添加成功')
                    onSave && onSave(id)
                    onClose && onClose()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { initValues休假人员 } = this.state
        return [
            {
                _checkgrid: '', name: '休假人员', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: initValues休假人员, onSearch: this.doGetSalaryPerson,
                columns: [
                    { _text: '人员姓名', minWidth: 150, flex: 1 },
                    { _text: '所在部门', minWidth: 150, flex: 1 },
                    { _text: '职务', minWidth: 150, flex: 1 },
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth={'800'}
            controls={[
                { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
            ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]
            }
        />
    }
}

export default connect()(SetAdjustmentPersonDiv)